import * as React from "react";

export function Telegram(props) {
  return (
    <svg
      width={58}
      height={53}
      viewBox="0 0 58 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M40.277 15.746h.042c.396 0 .765.114 1.067.31l-.006-.004c.22.177.368.425.404.704v.005a4.108 4.108 0 01.046 1.045v-.016c-.427 4.138-2.28 14.173-3.222 18.805-.398 1.962-1.182 2.618-1.942 2.681-1.65.142-2.902-1.002-4.5-1.967-2.503-1.51-3.917-2.45-6.345-3.923-2.808-1.7-.987-2.637.611-4.164.42-.402 7.692-6.489 7.835-7.04a.514.514 0 00-.133-.463.686.686 0 00-.351-.093.743.743 0 00-.243.042l.004-.002c-.251.052-4.248 2.483-11.99 7.29a5.61 5.61 0 01-3.074 1.047h-.011a21.464 21.464 0 01-4.558-1l.14.041c-1.78-.534-3.194-.816-3.073-1.72.065-.47.77-.952 2.115-1.445 8.287-3.322 13.813-5.512 16.578-6.57 3.05-1.49 6.587-2.715 10.306-3.51l.298-.054.002.002zM28.522 0C12.763.035 0 11.799 0 26.305c0 14.528 12.799 26.306 28.589 26.306s28.589-11.777 28.589-26.306C57.178 11.8 44.415.035 28.659 0h-.137z"
        fill="#FAFAFA"
      />
    </svg>
  );
}
